export const DashboardSidebarProps = {
  CLIENT_LOGO_ALT: 'client logo',
  DASHBOARD_INDEX: 'dashboard',
  COMPANY_DASHBOARD: 'company-dashboard',
  DASHBOARD_TEXT: 'Dashboard',
  CREATE_PRODUCT: 'product',
  HELP_MENU_LABEL: 'help',
  PROFILE: 'My Profile',
  NOTIFICATIONS: 'Notifications',

  PRODUCTS_ICON_ALT: 'products',
  PRODUCTS_INDEX: 'products',
  PRODUCT_LISTING: 'Product Listing',

  VALUE_CHAIN_ICON_ALT: 'value-chain',
  VALUE_CHAIN_INDEX: 'value-chain',
  VALUE_CHAIN: 'Value Chain',
  COMPANY_SETUP: 'company-setup',
  COMPANY: 'Company Setup',
  TARGETS: 'Climate Target',
  TargetPage: 'targets',
  PROCESSING_FACILITY: 'processing-facility',
  SUPPLIERS: 'suppliers',
  DASHBOARD: 'Dashboard',
  CARBON_ONE_LOGO_ALT: 'carbon one',
  SIDEBAR_BOTTOM_BACKGROUND: 'background',
  FARM: 'farm',
  FARM_COMMODITY: 'farm/all-commodities',
  UTILITY_DASHBOARD: 'utility-dashboard',
  UTILITY_DASHBOARD_TEXT: 'Utility Dashboard',
};
